<template>
  <div>
    <v-tabs
      v-model="viewPage"
      color="white"
      :slider-color="$vuetify.theme.primary"
      style="font-size: 18px"
    >
      <v-tab
        v-for="(item, index) in filterdMenuItem"
        :key="`menu-item-${index}`"
        style="text-transform: capitalize"
        ripple
        :href="`#${item.view}`"
        @click="updateSlug(item.view)"
        >{{ item.text }}</v-tab
      >
    </v-tabs>
    <Status v-if="view == 'status'" />
    <v-container class="mt-4">
      <Reward v-if="view == 'reward'" />
      <Member v-else-if="view == 'member'" />

      <Branch v-else-if="view == 'branch'" />
      <Product v-else-if="view == 'product'" />
      <ApproveReceipt v-else-if="view == 'ApproveReceipt'" />
      <Point v-else-if="view == 'point'" />
    </v-container>
  </div>
</template>

<script>
import Reward from './Reward'
import Status from '@/components/view/template/ecommerce/ecommerce-order-summary.vue'
import Member from './Member'
import Branch from './Branch'
import Product from './Product'
import Point from './Point'
import ApproveReceipt from './ApproveReceipt'

export default {
  components: {
    Reward,
    Status,
    Member,
    Branch,
    Product,
    Point,
    ApproveReceipt
  },
  data() {
    return {
      viewPage: 'member',
      menuItem: [
        {
          text: 'ข้อมูลสมาชิก',
          view: 'member'
        },
        {
          text: 'จัดการสาขา',
          view: 'branch'
        },
        {
          text: 'จัดการสินค้า',
          view: 'product'
        },
        {
          text: 'Point',
          view: 'point'
        },
        {
          text: 'การอนุมัติใบเสร็จ',
          view: 'ApproveReceipt'
        },
        {
          text: 'จัดการของรางวัล',
          view: 'reward'
        },
        {
          text: 'สถานะการจัดส่ง',
          view: 'status'
        }
      ]
    }
  },

  computed: {
    filterdMenuItem() {
      if (this.$store.state.privilege && this.$store.state.privilege.role) {
        var role = this.$store.state.privilege.role
        if (role == 'superadmin') return this.menuItem
        else if (role == 'admin') {
          // return this.menuItem.filter((el) => !['point'].includes(el.view))
          return this.menuItem
        } else if (['manager', 'accounting'].includes(role)) {
          return this.menuItem.filter((el) =>
            ['ApproveReceipt', 'status', 'member'].includes(el.view)
          )
        }
      } else {
        return this.menuItem
      }
    },
    view() {
      this.viewPage = this.$route.query.view ? this.$route.query.view : this.filterdMenuItem[0].view
      var result = this.$route.query.view ? this.$route.query.view : this.filterdMenuItem[0].view
      if (this.filterdMenuItem.some((el) => el.view == result)) {
        return result
      } else {
        return this.filterdMenuItem[0].view
      }
    }
  },
  methods: {
    updateSlug(view) {
      if (view !== this.view) {
        this.$router.replace({ query: { view } })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toacrm/main.vue